import {getReportParams, report} from '../../../middleware/report';


export function dwhMailingMethod({status,message,customerName,idNumber,param1,param2,ban,param3,actionType}) {
  let reportParams = getReportParams();
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'IDF Update Invoice Address';
  reportParams.channel = 'WebsiteBusiness';
  reportParams.actionType =actionType;
  reportParams.status = status;
  reportParams.messageText =message;
  reportParams.idNumber=idNumber;
  reportParams.customerName=customerName;
  reportParams.param1 = param1 || '';
  reportParams.param2 = param2  || '';
  reportParams.param3 = ban || '';
  reportParams.param5 = param3 || '';
  report(reportParams);
}
